import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { pickDataProps, pickAriaProps, pickComponentCommonProps } from '../../interfaces/commonProps';
import { useSpacing } from '../..';
import { StyledRoot, StyledCircularLoader, StyledLoaderContainer, StyledValue, StyledLabel, StyledProgressBar, StyledProgressBarTrain, circularLoaderSizes, StyledCircularTrain, StyledCircularTrack } from './Loader.styles';
var labelId = 0;

var getLabelId = function getLabelId() {
  return "Loader-Label-".concat(labelId++);
};

export var Loader = React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'circular' : _ref$variant,
      _ref$monochrome = _ref.monochrome,
      monochrome = _ref$monochrome === void 0 ? false : _ref$monochrome,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      displayValue = _ref.displayValue,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      label = _ref.label,
      ariaLabelledBy = _ref['aria-labelledby'],
      ariaLabel = _ref['aria-label'],
      restProps = _objectWithoutProperties(_ref, ["size", "variant", "monochrome", "value", "displayValue", "inverted", "label", "aria-labelledby", "aria-label"]);

  var determinate = false;
  var progress;

  if (typeof value === 'number') {
    determinate = true;
    value = Math.max(Math.min(Math.round(value), 100), 0);
    displayValue = displayValue || value.toString();
    progress = value / 100;
  }

  var progressType = determinate ? 'determinate' : 'continuous';
  var generatedLabelId = label && !(ariaLabelledBy || ariaLabel) ? getLabelId() : undefined;
  var resolvedAriaLabelledBy = ariaLabelledBy || generatedLabelId;

  var contextualProps = _objectSpread({}, resolvedAriaLabelledBy ? {
    'aria-labelledby': resolvedAriaLabelledBy
  } : {
    'aria-label': ariaLabel
  }, {}, typeof value === 'number' && {
    'aria-valuenow': value,
    'aria-valuemin': 0,
    'aria-valuemax': 100
  }, {}, displayValue && {
    'aria-valuetext': displayValue
  }, {}, pickDataProps(restProps), {}, pickAriaProps(restProps), {}, pickComponentCommonProps(restProps));

  return React.createElement(StyledRoot, _objectSpread({}, contextualProps, {
    inverted: inverted,
    role: "progressbar",
    title: displayValue,
    variant: variant,
    outerSpacing: useSpacing(restProps),
    ref: ref
  }), React.createElement(StyledLoaderContainer, {
    monochrome: inverted || monochrome,
    inverted: inverted,
    progress: progress,
    progressType: progressType,
    size: size,
    variant: variant
  }, function () {
    switch (variant) {
      case 'circular':
        {
          var dimensions = circularLoaderSizes[progressType][size];
          var radius = dimensions.diameter / 2;
          var svgCircleParameters = {
            cx: radius,
            cy: radius,
            r: radius - dimensions.stroke / 2
          };
          return React.createElement(React.Fragment, null, React.createElement(StyledCircularLoader, {
            progressType: progressType,
            viewBox: "0 0 ".concat(dimensions.diameter, " ").concat(dimensions.diameter)
          }, React.createElement(StyledCircularTrack, _objectSpread({}, svgCircleParameters)), React.createElement(StyledCircularTrain, _objectSpread({
            progressType: progressType
          }, svgCircleParameters))), determinate && React.createElement(StyledValue, {
            role: "presentation",
            size: size
          }, displayValue));
        }

      case 'linear':
        return React.createElement(StyledProgressBar, null, React.createElement(StyledProgressBarTrain, {
          progressType: progressType
        }));
    }
  }()), label && React.createElement(StyledLabel, {
    id: generatedLabelId,
    variant: variant
  }, label));
});
Loader.displayName = 'Loader';